import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';

export class Interest extends BaseModel {
  static get entity() {
    return 'interests';
  }

  static get fk() {
    return 'interest';
  }

  static get modes() {
    return {
      verify: 'VERIFY',
      learn: 'LEARN'
    };
  }

  static fields() {
    return {
      id: this.uid(),
      user: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      learning_unit_id: this.attr(null),
      mode: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      findOneByLearner(learningUnitId) {
        return this.get(`/interests/learner/learning-units/${learningUnitId}`);
      },

      createByLearner(learningUnitId, mode) {
        return this.post('/interests/learner', {
          learning_unit: learningUnitId,
          mode
        });
      }
    }
  };
}

export default Interest;
